<template>
    <field-group :model="info" :rules="ruleValidate">
        <Row :gutter="20">
            <Col span="24">
                <FormItem label="位置" prop="keyword" v-show="showKeyWordForm">
                    <auto-complete
                        v-model="info.keyword"
                        placeholder="请输入小区关键字"
                        @on-select="onSelect"
                        @on-search="onSearch"
                    >
                        <Option
                            v-for="item in tips"
                            :value="item.district + item.name"
                            :label="item.id"
                            :key="item.id"
                            >{{ item.district + item.name }}</Option
                        >
                    </auto-complete>
                </FormItem>
            </Col>
        </Row>
        <!-- 高德地图 -->
        <a-map
            class="fl-map"
            ref="amap"
            map-style="amap://styles/normal"
            :plugins="['Autocomplete', 'CitySearch']"
            :zoom="14"
            @load="onMapLoad"
        >
            <a-map-marker :position="position"></a-map-marker>
        </a-map>
        <Row :gutter="20">
            <Col span="12">
                <FormItem label="经度" prop="longitude">
                    <Input v-model="info.longitude" disabled></Input>
                </FormItem>
            </Col>
            <Col span="12">
                <FormItem label="纬度" prop="latitude">
                    <Input v-model="info.latitude" disabled></Input>
                </FormItem>
            </Col>
        </Row>
        <Row :gutter="20">
            <Col span="24">
                <FormItem label="详细地址" prop="addr">
                    <Input v-model="info.addr" disabled></Input>
                </FormItem>
                <!-- 隐藏field -->
                <FormItem label="行政区" prop="district" style="display: none">
                    <Input v-model="info.district"></Input>
                </FormItem>
            </Col>
        </Row>
    </field-group>
</template>

<script>
import { Field, AutoComplete } from 'ivux'
import { debounce } from '_u/helper'
import mAmap from '_g/amap/m-amap'

// 表单-地理定位
export default {
    name: 'form-location',
    mixins: [Field, mAmap],
    inheritAttrs: false,
    components: {
        AutoComplete,
    },
    props: {
        showKeyWordForm:{
          type: Boolean,
          default: true
        },
        onChange:{
          type: Function,
          default: null
        },
        populateType: {
            type: String,
            default: 'merge',
        },
        labelWidth: {
            type: Number,
            default: 100,
        },
        // POI类型
        type: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            info: {
                keyword: '',
                longitude: '',
                latitude: '',
                district: '',
                addr: '',
            },
            city: '',
            tips: [],
            position: null,
            auto: null,
        }
    },
    watch: {
        model: {
            handler(val) {
                if (val) {
                    Object.assign(this.info, val)
                }
            },
            immediate: true,
        },
    },
    computed: {
        ruleValidate() {
            return {
                longitude: [{ required: true, message: '经度必填' }],
                latitude: [{ required: true, message: '维度必填' }],
                addr: [{ required: true, message: '详细地址必填' }],
            }
        },
    },
    methods: {
        onMapLoad() {
            this.citySearch = new AMap.CitySearch()
            this.citySearch.getLocalCity((status, result) => {
                // 定位城市
                if (status === 'complete' && result.info === 'OK') {
                    this.city = result.city
                }
                // 输入查询
                this.auto = new AMap.Autocomplete({
                    city: this.city,
                    type: this.type,
                })
            })
            this.$watch(
                function () {
                    return this.info.longitude + this.info.latitude
                },
                function (val) {
                    if (val) {
                        this.position = [
                            this.info.longitude,
                            this.info.latitude,
                        ]
                        this.$refs.amap.map.setCenter(this.position)
                    } else {
                        this.position = null
                    }
                },
                {
                    immediate: true,
                }
            )
        },
        onSearch: debounce(400, function (val) {
            if (this.auto) {
                this.auto.search(val, (status, res) => {
                    this.status = status
                    if (this.status === 'complete') {
                        this.tips = res.tips.filter((v) => v.id && v.location)
                    } else {
                        this.tips = []
                    }
                })
            }
        }),
        // 位置选择
        onSelect({ value, label }) {
            var item = this.tips.find((v) => v.id == label)

            if (item) {
                this.info.longitude = item.location.lng
                this.info.latitude = item.location.lat
                this.info.addr = value
                this.info.district = item.district
                this.onChange(item.name)
            } else {
                this.info.longitude = ''
                this.info.latitude = ''
                this.info.addr = ''
                this.info.district = ''
            }
        },
    },
}
</script>

<style lang="less" scoped>
.fl {
    &-map {
        margin-bottom: 24px;
        height: 240px;
    }
}
</style>
